// Create a variable to store the event listener
import {ebus} from "@/vendor/ebus";

let pasteListener;

export function addPasteListener(pasteCallback) {
  pasteListener = (event) => {
    const pastedText = event.clipboardData.getData('text/plain');
    console.log('Pasted text:', pastedText);
    if(pastedText){
      ebus.$emit('pasteCallback', pastedText)
    }
    // Do something with the pasted text
  };

  document.addEventListener('paste', pasteListener);
}

// Function to remove the event listener
export function removePasteListener() {
  document.removeEventListener('paste', pasteListener);
}

export function copyToClipboard(text, _this) {
  navigator.clipboard.writeText(text)
    .then(() => {
      if (_this) {
        ebus.$emit('toast', 'Info copied to clipboard');
      }
    })
    .catch((err) => {
      console.error("Unable to copy text to clipboard", err);
    });
  // let ip = document.createElement("input");
  // ip.value = text;
  // ip.id = 'clipInput';
  // document.body.appendChild(ip);
  //
  // /* Get the text field */
  // // var myEl = document.getElementById("clipInput");
  // /* Select the text field */
  // ip.select();
  // ip.setSelectionRange(0, 999999); /*For mobile devices*/
  // /* Copy the text inside the text field */
  // document.execCommand("copy");

  // setTimeout(() => {
  //   document.body.removeChild(ip);
  // }, 2000);
}
